"use client"

import { Box, Grid2 as Grid, Skeleton } from "@mui/material"
import { MenuIcon } from "lucide-react"
import { usePathname } from "next/navigation"
import Logo from "../Logo"
import { HEADER_HEIGHT, TOP_BAR_HEIGHT } from "./constants"
const HIDDEN_PATHS: RegExp[] = [
    /^\/fa(?:\/v2)?\/products\/.+$/,
    /^\/fa\/v2\/profile\/.+$/,
]

export const HeaderLoading = ({ viewport, showTopBar }: {
    viewport?: string,
    showTopBar?: boolean,
}) => {
    const pathname = usePathname()
    const shouldHideHeader = viewport === "mobile" && HIDDEN_PATHS.some((pattern) => pattern.test(pathname));
    const topBarOffset = showTopBar ? TOP_BAR_HEIGHT : 0

    if (shouldHideHeader) {
        return null;
    }
    return (
        <Box sx={{
            height: {
                xs: HEADER_HEIGHT.mobile + topBarOffset,
                sm: HEADER_HEIGHT.tablet + topBarOffset,
                md2: HEADER_HEIGHT.desktop + topBarOffset
            },
        }}>
            {showTopBar && (
                <Box sx={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    left: 0,
                    height: topBarOffset,
                    bgcolor: '#101010',
                    zIndex: 999,
                }} />
            )}
            <Box sx={{
                position: 'fixed',
                top: topBarOffset,
                right: 0,
                left: 0,
                bgcolor: '#fff',
                zIndex: 998,
                boxShadow: 'rgba(0, 0, 0, 0.09) 0px 4px 11px'

            }}>
                <Grid container alignItems={{ xs: 'flex-start', md: 'center' }} sx={{
                    maxWidth: 1400,
                    height: {
                        xs: 56, sm: 112, md: 72
                    },
                    margin: 'auto',
                    boxSizing: 'content-box', px: { xs: 1, sm: 2 },
                }}>
                    <Grid size={{ xs: 4, md: 2 }} order={{ xs: 2, md: 1 }}>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', justifyContent: { xs: 'flex-end', sm: 'flex-start' },
                        }}>
                            <Logo type="mobile" />
                        </Box>
                    </Grid>
                    <Grid size={{ sm: 12, md: 7 }} order={{ sm: 3, md: 2 }} display={{ xs: 'none', sm: 'block' }}>
                        {/* <Box sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: { xs: 'flex-start', md: 'center' },
                            pl: { xs: 2, md: 0 }
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                                <Skeleton variant="rounded" animation="wave" width={80} height={24} sx={{ ml: 0 }} />
                                <Skeleton variant="rounded" animation="wave" width={80} height={24} sx={{ ml: 1 }} />
                                <Skeleton variant="rounded" animation="wave" width={80} height={24} sx={{ ml: 1 }} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                                <Skeleton variant="rounded" animation="wave" width={80} height={24} sx={{ ml: 0 }} />
                                <Skeleton variant="rounded" animation="wave" width={80} height={24} sx={{ ml: 1 }} />
                                <Skeleton variant="rounded" animation="wave" width={80} height={24} sx={{ ml: 1 }} />
                            </Box>
                        </Box> */}
                    </Grid>
                    <Grid size={{ xs: 8, md: 3 }} order={{ xs: 1, sm: 2, md: 3 }}>
                        <Box sx={{
                            display: "flex", alignItems: "center", gap: 1,
                            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
                            height: 56,
                        }}>
                            <Box sx={{
                                alignItems: 'center', justifyContent: 'center',
                                height: 42, width: 42, display: { xs: 'inline-flex', sm: 'none' }
                            }}>
                                <MenuIcon />
                            </Box>
                            {/* search */}
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 42, width: 42 }}>
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                            {/* cart + profile — same shape as HeaderAuthArea skeleton */}
                            <Skeleton variant="rounded" width={92} height={36} sx={{ borderRadius: '6px' }} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>

    )
}
